var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18C782E6-4219-4775-88C5-1F1D052E11C4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.77635684e-15 C18.6163909,1.77635684e-15 24,5.38283955 24,12 C24,17.8599461 19.7768372,22.749519 14.2154675,23.7922278 L14.2154675,23.7922278 L14.2154675,22.3809157 C19.0088496,21.3589842 22.6148519,17.0934975 22.6148519,12 C22.6148519,6.14697961 17.8530204,1.38514813 12,1.38514813 C6.14697961,1.38514813 1.38514813,6.14697961 1.38514813,12 C1.38514813,17.8537899 6.14697961,22.6156214 12,22.6156214 C12.245479,22.6156214 12.4886495,22.6040785 12.7302809,22.5871489 L12.7302809,22.5871489 L12.7302809,23.9761447 C12.4886495,23.9907657 12.245479,24.0007695 12,24.0007695 C5.38283955,24.0007695 1.77635684e-15,18.6171604 1.77635684e-15,12 C1.77635684e-15,5.38283955 5.38283955,1.77635684e-15 12,1.77635684e-15 Z M12.7803001,6.51035013 L12.7803001,11.3776068 L17.4898038,11.3776068 L17.4898038,12.7627549 L12.7803001,12.7627549 L12.7803001,17.4899577 L11.395152,17.4899577 L11.395152,12.7627549 L6.51019623,12.7627549 L6.51019623,11.3776068 L11.395152,11.3776068 L11.395152,6.51035013 L12.7803001,6.51035013 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Add-Circle-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/Liberty-Blue"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#13112B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#1A1446",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.000000, -38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.52cf997c3b9cee5d06a2ff82cfed70a6.svg";
export { ForwardRef as ReactComponent };